export * from "./generated-html-template.component";
